<ion-header class="shown-md">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-toggle id="customer-admin-content">
        <ion-button fill="clear" color="dark" class="mobile-menu-toggle">
          <ion-icon name="menu-outline"></ion-icon>
        </ion-button>
      </ion-menu-toggle>
    </ion-buttons>
    <ion-title>Outbound</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <app-messaging [communityId]="customerId"></app-messaging>
</ion-content>
